import useFilterSearchParams from 'common/hooks/useFilterSearchParams';
import { ReportsFilter, reportsFilterSearchParams } from 'common/types/SearchParams';

import { useFormik } from 'formik';

const useReportsFilter = (onSubmit: () => void) => {
  const { params, setFilter, clearFilter } = useFilterSearchParams<ReportsFilter>(reportsFilterSearchParams);

  const formikSubmit = (params: ReportsFilter) => {
    setFilter(params);
    onSubmit();
  };

  const formik = useFormik<ReportsFilter>({
    initialValues: params,
    onSubmit: formikSubmit,
    enableReinitialize: true,
  });

  const clearFormAndSearchParams = () => {
    formik.resetForm();
    clearFilter();
  };

  return { formik, clearFormAndSearchParams };
};

export default useReportsFilter;
